import EMICalc from "@/components/EMICalc";
import InquiryForm from "@/components/InquiryForm";

export default function EMIPage() {
  return (
    <div className="max-w-7xl mx-auto px-6 lg:px-10 py-12 md:py-16">
      <div className="text-[11px] uppercase tracking-[0.2em] text-gold font-semibold mb-2">Finance</div>
      <h1 className="font-heading font-extrabold text-3xl md:text-5xl text-forest tracking-tight leading-tight">Home Loan EMI Calculator</h1>
      <p className="text-muted-foreground text-sm mt-2 max-w-2xl">
        Get a realistic monthly EMI and total interest picture. Our loan desk works with multiple leading banks & NBFCs — get a pre-approved offer in 48 hours.
      </p>
      <div className="mt-10 grid lg:grid-cols-5 gap-10">
        <div className="lg:col-span-3">
          <EMICalc />
        </div>
        <div className="lg:col-span-2">
          <InquiryForm />
        </div>
      </div>
    </div>
  );
}
